import {ScrollView, View} from 'react-native';
import {Button} from 'react-native-paper';
import {Text} from '../../Components';
import {PageContainer} from '../../Containers';
import {useTheme} from '../../Hooks';
import {RootAboutScreenProps} from '../../Typings/NavigationTypes';
import {FEEDBACK_EMAIL, openFeedbackEmail} from '../../Utils/Contact';
import getStyles from './ADAPT-MH.styles';

type Props = RootAboutScreenProps;

const About: React.FC<Props> = ({navigation}) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <PageContainer withSafeArea withPadding>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.hero}>
          <Text
            fontSize={30}
            lineHeight={37}
            weight="black"
            accessibilityRole="header"
            style={styles.title}
          >
            ADAPT-MH is a clinician-guided mental health screening prototype.
          </Text>
          <Text fontSize={16} lineHeight={24} style={styles.subtitle}>
            It supports clinicians in guiding young people through questions about stress, mood,
            worry, sleep, and daily life, then prepares structured, non-diagnostic results to inform
            next steps.
          </Text>
        </View>

        <View style={styles.card}>
          <Text weight="bold" fontSize={17} style={styles.strongBody}>
            What this prototype does
          </Text>
          <Text style={styles.listItem}>
            - Uses the adaptive screening logic and model assets included in this app.
          </Text>
          <Text style={styles.listItem}>
            - Keeps screening results advisory and non-diagnostic.
          </Text>
          <Text style={styles.listItem}>
            - Supports clinician review of condition indicators, overall severity, and care
            guidance.
          </Text>
        </View>

        <View style={styles.softCard}>
          <Text style={styles.body}>
            This prototype supports, but does not replace, clinical judgment. Local referral
            contacts and formal translations need approval before real deployment.
          </Text>
        </View>

        <View style={styles.card}>
          <Text weight="bold" fontSize={17} style={styles.strongBody}>
            Feedback and questions
          </Text>
          <Text style={styles.listItem}>
            Send feedback about the prototype, or questions about shared research data, to the
            project team:
          </Text>
          <Text
            accessibilityRole="link"
            accessibilityLabel={`Email ${FEEDBACK_EMAIL}`}
            onPress={() => openFeedbackEmail('ADAPT-MH feedback')}
            style={[styles.listItem, styles.link]}
          >
            {FEEDBACK_EMAIL}
          </Text>
          <Text style={styles.footerNote}>
            Local referral contacts will be added when the implementation site approves them.
          </Text>
        </View>

        <Button
          mode="contained"
          onPress={() => navigation.navigate('Support', {urgent: true})}
          style={styles.button}
          buttonColor={theme.colors.error}
          textColor={theme.colors.textContrast}
        >
          Get urgent help
        </Button>
      </ScrollView>
    </PageContainer>
  );
};

export default About;
